
import { Component, Vue, Prop } from "vue-property-decorator"

@Component
export default class TransportDocumentWasteItem extends Vue {
    @Prop({ required: true })
    item!: any
    @Prop({ default: false })
    detail?: boolean

    translateUnit(unit: string) {
        return this.$t(`unit_${unit}`)
    }

    changeDeclaration(declaration: string) {
        this.item.declaration = declaration;
        this.$emit("save")
    }
}

